// extracted by mini-css-extract-plugin
export default {"runnerCard":"Parkrunner_runnerCard__8WHGp","parrot-container":"Parkrunner_parrot-container__35-zI"};